// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pqxs","left":"styles_left__3x4h7"};